<template>
  <div>
    <top :text="titletext"></top>
    <div class="search">
      <el-input
        class="input"
        placeholder="输入关键字搜索"
        v-model="search"
        prefix-icon="el-icon-search">
      </el-input>
      <el-button class="searchBtn" @click="toSearch">搜索</el-button>
    </div>
    <div v-if="res.lectures">
      <div v-for="item in res.lectures" :key="item.id">
        <div class="picture" @click="toDetail(item.id)">
          <img :src="item.thumbnail" alt="">
          <div>
            <span class="signUp" v-if="item.available">报名中</span>
            <span class="unSignUp" v-else>已结束</span>
            {{item.title}}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="noneClass">
      目前没有课程
    </div>
    <div style="height: 70px;"></div>
    <sidebar :selected="select"></sidebar>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import top from '../components/Top.vue'
import http from '../utils/http'

export default {
  name: 'course',
  components: { Sidebar, top },
  data () {
    return {
      titletext: '课程',
      select: 2,
      res: Object,
      search: ''
    }
  },
  created () {
    http['get']('lectures').then((res) => { this.res = res })
  },
  methods: {
    toDetail: function (id) {
      this.$router.push({name: 'courseDetail', query: {id: id}})
    },
    toSearch: function () {
      http['get'](`lectures/search?q=${this.search}`).then((res) => { this.res = res })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search {
  display: flex;
}
.input {
  flex: 8;
  margin: 0.8rem 0.8rem 0 0.8rem ;
}
.input>>>.el-input__inner {
  border-radius: 20px;
  background: #f5f5f5;
  border: 0;
}
.searchBtn {
  flex: 1;
  color: #fff;
  background: #ffb949;
  border: 0;
  border-radius: 40px;
  margin: 0.8rem 0.8rem 0 0 ;

}
.picture {
  border-radius: 10px;
  box-shadow: 0 5px 5px rgba(0,0,0,.07);
  margin: 0.8rem 0.8rem 0 0.8rem;
}
.picture img{
  width: 100%;
  border-radius: 10px 10px 0 0;
}
.picture div{
  height: 50px;
  text-align: left;
  line-height: 50px;
  font-family: "PingFang-SC-Medium";
  color: #333;
  margin-left: 5px;
}
.signUp {
  font-size: 12px;
  color: #fff;
  background: rgb(0, 137, 25);
  padding: 3px;
  border-radius: 3px;
}
.unSignUp {
  font-size: 12px;
  color: #fff;
  background: #999;
  padding: 3px;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/class/course.vue